import * as actionTypes from "./actionTypes";
// import { productData, searchKeys } from "../../data";
import { firebase } from "../../firebase/index";
import { collections, documents } from "../../firebase/firestoreNameSpaces";
import { closeAllModal, sortArrayObjects, string_to_slug } from "../utility";

export const fetchHomeProducts = () => (dispatch) =>
  new Promise(async (resolve, reject) => {
    try {
      dispatch({
        type: actionTypes.HOMEPRODUCTS_LOADING,
        payload: { loading: true },
      });

      let db = firebase.firestore();
      let docs = (await db.collection(collections.PRODUCTS).limit(10).get())
        .docs;
      let products = [];
      docs.map((product) => {
        products.push(product.data());
      });

      dispatch({
        type: actionTypes.FETCH_HOMEPRODUCTS,
        payload: { productData: products, loading: false },
      });

      return resolve(products);
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_HOMEPRODUCTS,
        payload: { productData: [], loading: false },
      });

      reject(error);
      alert(error);
    }
  });
// export const fetchHomeSectionProducts = ()=>{
//   return async dispatch=>{
//     try{

//       dispatch({
//         type: actionTypes.HOMEPRODUCTS_LOADING,
//         payload: { loading: true },
//       });
//       let db = firebase.firestore();
//       let homeSections = (await db.collection(collections.K5METADATA).doc(documents.HOMESECTIONS).get()).data();
//       if(homeSections){

//       }else{
//         //Some Problem
//         dispatch({
//           type: actionTypes.HOMEPRODUCTS_LOADING,
//           payload: { loading: false },
//         });
//       }

//     }catch(error){
//       return alert(error)
//     }
//   }
// }
export const fetchSingleProduct = (productName, productId) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: actionTypes.HOMEPRODUCTS_LOADING,
          payload: { loading: true },
        });
        let db = firebase.firestore();
        let data = (
          await db.collection(collections.PRODUCTS).doc(productId).get()
        ).data();
        dispatch({
          type: actionTypes.FETCH_HOMEPRODUCTS,
          payload: { singleProduct: data, loading: false },
        });
        resolve(data);
      } catch (error) {
        dispatch({
          type: actionTypes.HOMEPRODUCTS_LOADING,
          payload: { loading: false },
        });
        reject(error);
        return alert(error);
      }
    });
  };
};

export const fetchSearchKeys = () => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: actionTypes.HOMEPRODUCTS_LOADING,
          payload: { searchLoading: true },
        });
        let db = firebase.firestore();
        let data = (
          await db
            .collection(collections.K5METADATA)
            .doc(documents.SEARCHKEYS)
            .get()
        ).data();
        if (data) {
          dispatch({
            type: actionTypes.HOMEPRODUCTS_LOADING,
            payload: {
              searchKeys: data.keywords ? data.keywords : [],
              searchLoading: false,
            },
          });
          resolve(data);
        } else {
          dispatch({
            type: actionTypes.HOMEPRODUCTS_LOADING,
            payload: { searchKeys: [], searchLoading: false },
          });
          resolve([]);
        }
      } catch (error) {
        dispatch({
          type: actionTypes.HOMEPRODUCTS_LOADING,
          payload: { searchKeys: null, searchLoading: false },
        });
        reject(error);
        return alert(error);
      }
    });
  };
};
export const fetchSearchKeysAdmin = () => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: actionTypes.HOMEPRODUCTS_LOADING,
          payload: { searchLoading: true },
        });
        let db = firebase.firestore();
        let data = (
          await db
            .collection(collections.K5METADATA)
            .doc(documents.SEARCHKEYS)
            .get()
        ).data();
        if (data) {
          let totalKeys = [];
          let userKeywords = data.keywords ? data.keywords : [];
          totalKeys.push(...userKeywords);
          let adminKeywords = (
            await db
              .collection(collections.K5METADATA)
              .doc(documents.SEARCHKEYSADMIN)
              .get()
          ).data();
          if (adminKeywords.keywords) {
            totalKeys.push(...adminKeywords.keywords);
          }
          totalKeys = [...new Set(totalKeys)];
          dispatch({
            type: actionTypes.HOMEPRODUCTS_LOADING,
            payload: {
              searchKeys: totalKeys,
              searchLoading: false,
            },
          });
          resolve(totalKeys);
        } else {
          dispatch({
            type: actionTypes.HOMEPRODUCTS_LOADING,
            payload: { searchKeys: [], searchLoading: false },
          });
          resolve([]);
        }
      } catch (error) {
        dispatch({
          type: actionTypes.HOMEPRODUCTS_LOADING,
          payload: { searchKeys: null, searchLoading: false },
        });
        reject(error);
        return alert(error);
      }
    });
  };
};

export const fecthSearchProducts = (searchKey, suggestion) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.HOMEPRODUCTS_LOADING,
        payload: { loading: true },
      });
      let limit = getState().homeProducts.limit;
      let sug = null;
      if (suggestion) {
        sug = string_to_slug(suggestion); //
      } else {
        sug = string_to_slug(searchKey);
      }
      console.log(sug);
      let db = firebase.firestore();
      let docs = (
        await db
          .collection(collections.PRODUCTS)
          .where("searchSpace", "array-contains", sug)
          .limit(limit)
          .get()
      ).docs;

      if (!docs.length) {
        docs = (
          await db
            .collection(collections.PRODUCTS)
            .where(
              "searchSpace",
              "array-contains-any",
              sug.split("-").splice(0, 10)
            )
            .limit(limit)
            .get()
        ).docs;
      }

      if (docs.length) {
        let products = [];
        docs.map((doc) => {
          products.push(doc.data());
        });
        let lastDoc = docs[docs.length - 1];
        dispatch({
          type: actionTypes.FETCH_HOMEPRODUCTS,
          payload: {
            searchProductData: products,
            loading: false,
            lastDoc,
            leadsexhausted: docs.length < limit ? true : false,
          },
        });
      } else {
        dispatch({
          type: actionTypes.FETCH_HOMEPRODUCTS,
          payload: {
            leadsexhausted: docs.length < limit ? true : false,
            loading: false,
            searchProductData: [],
          },
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_HOMEPRODUCTS,
        payload: {
          searchProductData: [],
          loading: false,
          searchProductData: [],
        },
      });
      return alert(error);
    }
  };
};

export const loadMoreSearchProducts = (
  searchKey,
  suggestion,
  leadsexhausted,
  lastDoc,
  limit
) => {
  return async (dispatch, getState) => {
    try {
      if (leadsexhausted) {
        return null;
      }

      dispatch({
        type: actionTypes.HOMEPRODUCTS_LOADING,
        payload: { loadMore: true },
      });

      let sug = null;
      if (suggestion) {
        sug = string_to_slug(suggestion); //
      } else {
        sug = string_to_slug(searchKey);
      }

      let db = firebase.firestore();
      let docs = (
        await db
          .collection(collections.PRODUCTS)
          .where("searchSpace", "array-contains", sug)
          .startAfter(lastDoc)
          .limit(limit)
          .get()
      ).docs;

      if (!docs.length) {
        docs = (
          await db
            .collection(collections.PRODUCTS)
            .where(
              "searchSpace",
              "array-contains-any",
              sug.split("-").splice(0, 10)
            )
            .startAfter(lastDoc)
            .limit(limit)
            .get()
        ).docs;
      }

      if (docs.length) {
        let products = getState().homeProducts.searchProductData.concat();
        docs.map((doc) => {
          products.push(doc.data());
        });
        let lastDoc = docs[docs.length - 1];
        dispatch({
          type: actionTypes.FETCH_HOMEPRODUCTS,
          payload: {
            searchProductData: products,
            loadMore: false,
            lastDoc,
            leadsexhausted: docs.length < limit ? true : false,
          },
        });
      } else {
        dispatch({
          type: actionTypes.FETCH_HOMEPRODUCTS,
          payload: {
            leadsexhausted: docs.length < limit ? true : false,
            loadMore: false,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_HOMEPRODUCTS,
        payload: { searchProductData: [], loadMore: false },
      });
      return alert(error);
    }
  };
};
export const deleteProduct = (productId) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: actionTypes.HOMEPRODUCTS_LOADING,
          payload: { deleteProductLoading: true },
        });
        let db = firebase.firestore();
        await db.collection(collections.PRODUCTS).doc(productId).delete();
        dispatch({
          type: actionTypes.HOMEPRODUCTS_LOADING,
          payload: { deleteProductLoading: false },
        });
        let searchProducts = getState().homeProducts.searchProductData;
        searchProducts = searchProducts.filter((pr) => pr.id != productId);
        dispatch({
          type: actionTypes.FETCH_HOMEPRODUCTS,
          payload: { searchProductData: searchProducts },
        });
        resolve(true);
      } catch (error) {
        reject(false);
        dispatch({
          type: actionTypes.HOMEPRODUCTS_LOADING,
          payload: { deleteProductLoading: false },
        });
        return alert(error);
      }
    });
  };
};

const checkWorkoutPlanExist = (workouts, workoutPlanName) => {
  if (!workouts) {
    return false;
  }
  return workouts.filter(
    (obj) =>
      obj.title.toLowerCase().trim() == workoutPlanName.toLowerCase().trim()
  ).length;
};

export const fetchHomeSections = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { sectionLoading: true },
      });

      let db = firebase.firestore();
      let snapshot = await db
        .collection(collections.K5METADATA)
        .doc(documents.HOMESECTIONS)
        .onSnapshot((snapshot) => {
          let data = snapshot.data();

          let workoutPlans = [];
          for (let docKey in data) {
            let category = data[docKey];
            if (!category.products) {
              category.products = [];
            }
            workoutPlans.push(category);
            workoutPlans = sortArrayObjects(workoutPlans, "sequence");
          }
          // console.log(workoutPlans);
          dispatch({
            type: actionTypes.HOME_SECTION_CONTROLS,
            payload: { homeSections: workoutPlans, sectionLoading: false },
          });
        });
    } catch (error) {
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { homeSections: [], sectionLoading: false },
      });
      return alert(error);
    }
  };
};
export const fetchHomeSectionsClient = () => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { loading: true },
      });

      let db = firebase.firestore();
      let snapshot = await db
        .collection(collections.K5METADATA)
        .doc(documents.HOMESECTIONS)
        .get();

      let data = snapshot.data();

      let workoutPlans = [];
      for (let docKey in data) {
        let category = data[docKey];
        if (!category.products) {
          category.products = [];
        }
        workoutPlans.push(category);
        workoutPlans = sortArrayObjects(workoutPlans, "sequence");
      }
      // console.log(workoutPlans);
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { homeSections: workoutPlans, loading: false },
      });
      return resolve(true);
    } catch (error) {
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { homeSections: [], sectionLoading: false },
      });
      alert(error);
      return reject(false);
    }
  });
};
export const addHomeSection = (plan, workout_plans) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { addPlanLoading: true },
      });

      if (checkWorkoutPlanExist(workout_plans, plan.title)) {
        dispatch({
          type: actionTypes.WORKOUT_CONTROLS,
          payload: { addPlanLoading: false },
        });
        return alert("Section Exist. Please Enter different title");
      }

      let db = firebase.firestore();
      const batch = db.batch();

      let categoryId = db.collection(collections.K5METADATA).doc().id;
      plan["id"] = categoryId;

      let c2 = db
        .collection(collections.K5METADATA)
        .doc(documents.HOMESECTIONS);
      batch.set(c2, { [categoryId]: plan }, { merge: true });

      await batch.commit();

      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { addPlanLoading: false },
      });
      return alert("Section Added Successfully...");
    } catch (error) {
      dispatch({
        type: actionTypes.WORKOUT_CONTROLS,
        payload: { addPlanLoading: false },
      });
      return alert(error);
    }
  };
};
export const editHomeSection = (editedSection, actualSections) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { editSectionLoading: true },
      });
      actualSections = actualSections.filter((pl) => {
        if (pl.id != editedSection.id) {
          return true;
        }
      });

      if (checkWorkoutPlanExist(actualSections, editedSection.title)) {
        dispatch({
          type: actionTypes.HOME_SECTION_CONTROLS,
          payload: { editSectionLoading: false },
        });
        return alert("Section Exists. Please choose a different Section title");
      }
      let db = firebase.firestore();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.HOMESECTIONS)
        .set(
          {
            [editedSection.id]: { ...editedSection },
          },
          { merge: true }
        );
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { editSectionLoading: false },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { editSectionLoading: false },
      });
      return alert(error);
    }
  };
};
export const deleteHomeSection = (sectionId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { deleteProductLoading: true },
      });
      let db = firebase.firestore();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.HOMESECTIONS)
        .set(
          {
            [sectionId]: firebase.firestore.FieldValue.delete(),
          },
          { merge: true }
        );

      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { deleteProductLoading: false },
      });
      window.location.reload();
    } catch (error) {
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { deleteProductLoading: false },
      });
      return alert(error);
    }
  };
};
export const addProductToSection = (sectionId, productId) => {
  return (dispatch, getState) => {
    try {
      let db = firebase.firestore();
      db.collection(collections.K5METADATA)
        .doc(documents.HOMESECTIONS)
        .set(
          {
            [sectionId]: {
              products: firebase.firestore.FieldValue.arrayUnion(productId),
            },
          },
          { merge: true }
        );
    } catch (error) {
      return alert(error);
    }
  };
};
export const removeProductFromSection = (sectionId, productId) => {
  return async (dispatch, getState) => {
    try {
      let homeSectionProducts = {
        ...getState().homeProducts.homeSectionProducts,
      };

      let db = firebase.firestore();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.HOMESECTIONS)
        .set(
          {
            [sectionId]: {
              products: firebase.firestore.FieldValue.arrayRemove(productId),
            },
          },
          { merge: true }
        );
      if (homeSectionProducts[sectionId]) {
        let products = homeSectionProducts[sectionId].filter(
          (pr) => pr.id != productId
        );
        homeSectionProducts[sectionId] = products;
      }
      let newSectionProducts = homeSectionProducts;
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { homeSectionProducts: newSectionProducts },
      });
    } catch (error) {
      return alert(error);
    }
  };
};
export const fetchSectionProductsFromArrayOfIds = (sectionId, productIds) => {
  return async (dispatch, getState) => {
    try {
      let homeSectionProducts = getState().homeProducts.homeSectionProducts;

      // if (homeSectionProducts[sectionId]) {
      //   return dispatch({
      //     type: actionTypes.HOME_SECTION_CONTROLS,
      //     payload: {
      //       homeSectionProducts: homeSectionProducts,
      //       sectionProductsLoading: false,
      //     },
      //   });
      // }
      // console.log("Fetching Products");
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { sectionProductsLoading: true },
      });

      if (!productIds.length) {
        // homeSectionProducts[sectionId] = [];
        return dispatch({
          type: actionTypes.HOME_SECTION_CONTROLS,
          payload: {
            homeSectionProducts: homeSectionProducts,
            sectionProductsLoading: false,
          },
        });
      }

      let fetched_products = [];
      let db = firebase.firestore();
      if (productIds.length <= 10) {
        let docs = (
          await db
            .collection(collections.PRODUCTS)
            .where("id", "in", productIds)
            .get()
        ).docs;
        docs.map((doc) => {
          fetched_products.push(doc.data());
        });
      } else {
        for (let i = 0; i < productIds.length; i++) {
          try {
            let product = (
              await db.collection(collections.PRODUCTS).doc(productIds[i]).get()
            ).data();
            if (product) {
              fetched_products.push(product);
            }
          } catch (error) {}
        }
      }

      homeSectionProducts[sectionId] = fetched_products;

      // console.log(homeSectionProducts);
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: {
          homeSectionProducts: { ...homeSectionProducts },
          sectionProductsLoading: false,
        },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.HOME_SECTION_CONTROLS,
        payload: { homeSectionProducts: [], sectionProductsLoading: false },
      });
      return alert(error);
    }
  };
};
export const setVisiblityOfSection = (sectionId, status) => {
  return async (dispatch) => {
    let db = firebase.firestore();
    await db
      .collection(collections.K5METADATA)
      .doc(documents.HOMESECTIONS)
      .set(
        {
          [sectionId]: {
            visible: status,
          },
        },
        { merge: true }
      );
  };
};
